import { type Targetable, TargetableClass } from '@feathr/blackbox';
import { useStore } from '@feathr/extender/state';
import type { ListResponse } from '@feathr/rachis';

const OMNI_SLICE_INCLUDE_PERCENTS = ['10', '20', '30', '40', '50', '60', '70', '80', '90', '100'];

interface IUseOmniSliceTargetablesReturn {
  omniSliceTargetables: ListResponse<Targetable>;
}

function useOmniSliceTargetables(): IUseOmniSliceTargetablesReturn {
  const { Targetables } = useStore();

  const omniSliceTargetables = Targetables.list({
    filters: {
      _cls: TargetableClass.omni_slice,
      include_percent__in: OMNI_SLICE_INCLUDE_PERCENTS,
    },
  });

  return { omniSliceTargetables };
}

export default useOmniSliceTargetables;
